// Estilos dos forms da landing (réplica do site modelo, feature 060).
// Literais em vez de tokens: a landing é dark fixo, independente do tema do painel.
export const glassInput =
  'h-11 rounded-xl border-white/[0.06] bg-white/[0.03] text-white placeholder:text-slate-500 focus-visible:border-primary';

export const glassLabel = 'text-[11px] font-medium uppercase tracking-wider text-slate-400';
